// Names are display text, not identifiers: symbols, emoji and numeric nicknames
// are all valid. Trim only to detect blankness; return the supplied text intact.
export function firstNonBlankText(...values) {
  return values.find(value => typeof value === 'string' && value.trim().length > 0) || null;
}

export function chatDisplayName(chat) {
  return firstNonBlankText(chat?.profile_name, chat?.customer_name, chat?.phone, chat?.username) || 'Unknown';
}
